import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import MarqueeText from '../components/MarqueeText';
import './About.css';

export default function About() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    supabase
      .from('site_settings')
      .select('key, value')
      .then(({ data }) => {
        if (!data) return;
        const map = {};
        data.forEach(row => { map[row.key] = row.value; });
        setSettings(map);
      });
  }, []);

  // ─── Replace these with your real Supabase Storage URLs ───────────────────
  const photos = [
    'https://shtrihmwkxfemhhquich.supabase.co/storage/v1/object/public/thumbnails/IMG_20251020_193327.jpg',
    'https://shtrihmwkxfemhhquich.supabase.co/storage/v1/object/public/thumbnails/face.jpg',
    'https://shtrihmwkxfemhhquich.supabase.co/storage/v1/object/public/thumbnails/cato.jpg',
    'https://shtrihmwkxfemhhquich.supabase.co/storage/v1/object/public/thumbnails/dar.jpg',
    'https://shtrihmwkxfemhhquich.supabase.co/storage/v1/object/public/thumbnails/cata.jpeg',
  ];
  // ────────────────────────────────────────────────────────────────────────────

  return (
    <main className="about">
      {/* Marquee hero */}
      <section className="about__hero">
        <MarqueeText text={settings.about_headline || 'WHO ARE YOU?'} dark speed={22} />
        <div className="about__hero-body">
          <p className="about__intro">
            {settings.about_intro || 'My name is Ashutosh-Karmakar \'ashu\, and I am a motion designer in India,Kolkata.\ Full time video editor creating engaging edits'}
          </p>
        </div>
      </section>

      {/* Photo strip */}
      <div className="about__photos">
        {photos.map((url, i) => (
          <div key={i} className="about__photo">
            <img src={url} alt={`About photo ${i + 1}`} />
          </div>
        ))}
      </div>

      {/* About content */}
      <section className="about__content">
        <div className="about__content-inner">
          <div className="about__from">
            <p className="about__label">From...</p>
            <div className="about__category-list">
              <div className="about__col">
                <div className="about__cat-item">
                  <span className="about__chevron">›</span>
                  <span className="about__cat-name">Commercials</span>
                </div>
                <div className="about__cat-item">
                  <span className="about__chevron">›</span>
                  <span className="about__cat-name">Short-form</span>
                </div>
              </div>
              <div className="about__col">
                <div className="about__cat-item about__cat-item--bold">
                  <span className="about__chevron">›</span>
                  <span className="about__cat-name">Long-form</span>
                </div>
              </div>
            </div>
            <p className="about__tagline">...I direct content that grows your brand.</p>
          </div>

          <div className="about__cta-block">
            <p className="about__cta-text">
              {settings.about_body || 'I love directing and editing brand contents. Contact me to bring your ideas to life!'}
            </p>
          </div>
        </div>
      </section>

      {/* Page nav */}
      <div className="about__page-nav">
        <Link to="/work" className="about__page-nav-item">← WORK</Link>
        <Link to="/contact" className="about__page-nav-item">CONTACT →</Link>
      </div>
    </main>
  );
}
